module.exports = __webpack_public_path__ + "/images/cover-fr-hero.4eabf34.png";